module.exports = __webpack_public_path__ + "back_mountain.c24dab5e2d97083f7085.jpg";


//////////////////
// WEBPACK FOOTER
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/assets/img/back_mountain.jpg
// module id = ../../../../../client/assets/img/back_mountain.jpg
// module chunks = styles